import React, { useState } from "react";
import { shape, string, bool, arrayOf } from "prop-types";
import { Link } from "react-router-dom";
import * as style from "./styles.module.scss";
import SearchBox from "../SearchBox";
import { sortBy } from "../../helpers/utils";

const AutocompleteBox = ({ className = "", disabled = false, items }) => {
  const [inputValue, setInputValue] = useState("");

  const filteredItems =
    items &&
    sortBy(
      items.filter((_elem) =>
        _elem.title.toLowerCase().includes(inputValue.toLowerCase())
      ),
      "title"
    );

  return (
    <div className={style.autocomplete__wrapper}>
      <SearchBox
        value={inputValue}
        className={`${className} ${style.autocomplete__searchbox}`}
        onChange={setInputValue}
        placeholder={"Search"}
        onCloseClick={() => setInputValue("")}
        disabled={disabled}
      />
      <ul
        className={`${style.autocomplete__items} ${
          inputValue !== "" ? "d-block" : "d-none"
        }`}
      >
        {filteredItems && filteredItems.length !== 0 ? (
          <span>
            {filteredItems.map((_elem, _index) => (
              <Link
                to={`${_elem.link}`}
                className={style.autocomplete__listing}
                key={`${_elem.jobTitle}${_index}`}
              >
                <span className={style.autocomplete__listing_title}>
                  {_elem.title}
                </span>
                <span className={style.autocomplete__listing_subtitle}>
                  {_elem.subtitle}
                </span>
              </Link>
            ))}
            <Link
              to="/profile/edit/bookings/all"
              className={style.autocomplete__viewAll}
            >
              View all vacancies
            </Link>
          </span>
        ) : (
          <article className={style.autocomplete__empty_wrapper}>
            <h4 className={style.autocomplete__empty_title}>
              Sorry, we couldn&apos;t find any matches for
            </h4>
            <p className={style.autocomplete__empty_value}>{inputValue}</p>
            <p className={style.autocomplete__empty_footer}>
              Please try searching with another term.
            </p>
            <Link
              to="/profile/edit/bookings/all"
              className={style.autocomplete__viewAll}
            >
              View all vacancies
            </Link>
          </article>
        )}
      </ul>
    </div>
  );
};

AutocompleteBox.propTypes = {
  className: string,
  disabled: bool,
  items: arrayOf(
    shape({
      title: string.isRequired,
      subtitle: string.isRequired,
      link: string.isRequired,
    })
  ),
};

export default AutocompleteBox;
